export const app_Name = "IdealBot Admin";
export const copyright =
  `© ${new Date().getFullYear()} IdealCorp. All rights reserved.`;
